import { useState } from "react"
import { queryClient } from "../../.."
import { Botao } from "../../../shared/components/Botao"
import { LoadingPage } from "../../../shared/components/LoadingPage"
import { Sidebar } from "../../../shared/components/MenuSidebar/Sidebar"
import { ConfirmDeleteModal } from "../../../shared/components/Modal/ConfirmDeleteModal"
import { Navbar } from "../../../shared/components/Navbar"
import { PageHeader } from "../../../shared/components/PageHeader/PageHeader";
import { TableInfo } from "../../../shared/components/Table";
import { IconAdicionar } from "../../../shared/Icons/IconAdicionar";
import { IconFolder } from "../../../shared/Icons/IconFolder";
import { IconVisibility } from "../../../shared/Icons/IconVisibility";
import { SimpleFilter } from "../../../shared/SimpleFilter";
import { FormCliente } from "../components/FormNovoCliente";
import { VisualizarCliente } from "../components/ModalVisualizar";
import useGetClientes from "../hooks/useGetClientes";
import deleteCliente from "../queries/deleteCliente";
import { colunas } from "../util/Colunas";

const pageName = "Clientes";

export function Clientes() {
  const [visible, setVisible] = useState<boolean>(false);
  const [visibleDelete, setVisibleDelete] = useState(false);
  const [valueInput, setValueInput] = useState<string>("");
  const [search, setSearch] = useState<string>("");
  const [clienteId, setClienteId] = useState<number>();
  const [page, setPage] = useState<number>(1);

  const { data: clientes, isLoading } = useGetClientes(search, page);

  function handleVisualizar(id?: number) {
    setClienteId(id);
    setVisible(!visible);
  }

  function handleCloseVisualizar() {
    setClienteId(undefined);
    setVisible(!visible);
  }

  const columns = [
    ...colunas,
    {
      title: "Ações",
      dataIndex: "action",
      key: "action",
      width: 50,
      render: (text: any, record: any, index: any) => {
        return (
          <div className=" flex justify-center gap-3">
            <button
              className="bg-gray-400 hover:bg-primary-hover p-1 text-gray-100 rounded-full"
              onClick={() => handleVisualizar(record.ClienteId)}
            >
              <IconVisibility width="20" height="20" />
            </button>
          </div>
        );
      },
    },
  ];

  async function onDelete() {
    clienteId && await deleteCliente(clienteId).then((r) => {
      r?.status === 200 && setVisibleDelete(!visibleDelete)
    });
    queryClient.invalidateQueries()
    setClienteId(undefined)
  }

  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-row">
        <Sidebar />
        <Navbar />
      </div>
      <div className="flex flex-col pl-[10rem] w-[85%] mx-auto">
        <PageHeader 
          titulo={pageName}
          icon={<IconFolder />}
          componente={
            <div className="flex flex-row justify-center items-center gap-4">
              <SimpleFilter
                placeholder="Pesquisar cliente"
                value={valueInput}
                onChange={(e: any) => setValueInput(e.target.value)}
                onClick={() => {
                  setSearch(valueInput);
                  if(valueInput) {
                    setPage(1);
                  }
                }}
                onCancel={() => {
                  setSearch("");
                  setValueInput("");
                }}
              />
              <Botao
                texto="Novo"
                icon={<IconAdicionar color="#fff" />}
                onClick={() => setVisible(!visible)}
                className="bg-primary hover:bg-primary-hover text-white self-center"
              />
            </div>
          }
        />
        {clienteId ? (
          <VisualizarCliente
            idCliente={clienteId}
            deleteModal={() => {
              handleVisualizar(clienteId);
              setVisibleDelete(!visibleDelete);
            }}
            openModal={handleCloseVisualizar}
            visible={visible}
          />
        ) : (
          <FormCliente
            openModal={() => setVisible(!visible)}
            visible={visible}
          />
        )}

        {!clientes ? (
          <div className="h-[80vh] flex justify-center items-center">
            <LoadingPage />
          </div>
        ) : (
          <TableInfo
            loading={isLoading}
            dataSource={clientes?.items ?? []}
            columns={columns}
            pagination={{
              current: page,
              pageSize: clientes?.meta?.itemsPerPage,
              total: clientes?.meta?.totalItems,
              onChange(p) {
                setPage(p);
              },
            }}
          />
        )}

        <ConfirmDeleteModal
          isModalOpen={visibleDelete}
          title="Deletar Cliente"
          mensagem="Você tem certeza que desejar excluir este cliente?"
          onDelete={onDelete}
          closeModal={() => setVisibleDelete(!visibleDelete)}
        />
      </div>
    </div>
  );
}
